import axios, { AxiosRequestConfig } from 'axios';

import { DataResponse } from '../types/api';

const URL = '/v2/sitter-branch-onboard-url';

interface SitterBranchOnboardUrlRequestDTO {
  sitterId: number;
}

interface SitterBranchOnboardUrlDTO {
  url: string | null;
}

class SitterBranchOnboardService {
  static create(
    data: SitterBranchOnboardUrlRequestDTO,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SitterBranchOnboardUrlDTO>> {
    return axios.post(URL, data, config);
  }
}

export {
 SitterBranchOnboardService, SitterBranchOnboardUrlRequestDTO, SitterBranchOnboardUrlDTO 
};
